import React from 'react';
import { ButtonWithLink } from '../button/Button';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link } from '../link';
import { Wrapper } from '../../utils/components';
import './MainMenu.scss';
import { getColorsCategory } from '../../utils/functions';
import { getLinkInformation } from '../../utils/functions';
import ContenutoHtmlInner from '../../molecules/helpers-contenuto-html/ContenutoHtmlInner';
import classNames from 'classnames';
import ArrowRightCircle from '../../atoms/static-icons/arrow-right-circle';

function MegaMenuPanel({ panel }) {
  const linkInformation = getLinkInformation(
    panel.labelLinkPanel.content.internalLinkPanel?.value?.link,
    panel.labelLinkPanel.content.externalLinkPanel.value,
    panel.labelLinkPanel.value,
    panel.labelLinkPanel.content.internalLinkPanel?.value?.pageTitle?.value
  );

  return (
    <>
      {panel.panelNotVisible.value === false &&
        (panel.detailModulePanel?.value?.__typename ===
          'LiferayModuleDetailProduct' ||
          panel.detailModulePanel?.value?.__typename ===
            'LiferayModuleDetailBlog' ||
          panel.detailModulePanel?.value?.__typename ===
            'LiferayModuleDetailIniziative' ||
          !panel?.detailModulePanel) && (
          <div
            data-submodule-name='megamenu-panel'
            className={classNames(
              'main-nav-secondary__panel',
              {
                'main-nav-secondary__panel--highlight-product':
                  panel?.detailModulePanel?.value?.__typename ===
                  'LiferayModuleDetailProduct',
              },
              {
                'main-nav-secondary__panel--highlight-blog':
                  panel?.detailModulePanel?.value?.__typename ===
                    'LiferayModuleDetailBlog' ||
                  panel?.detailModulePanel?.value?.__typename ===
                    'LiferayModuleDetailIniziative',
              }
            )}
          >
            {panel?.imagePanel?.node?.gatsbyImageData &&
              !panel.detailModulePanel?.value && (
                <GatsbyImage
                  className='main-nav-secondary__highlight-image'
                  image={getImage(panel.imagePanel.node.gatsbyImageData)}
                  alt={panel?.imagePanel?.value?.title || ''}
                />
              )}
            {panel.detailModulePanel?.value?.__typename ===
              'LiferayModuleDetailProduct' &&
              panel?.detailModulePanel?.value?.cardDetails?.content?.cardImage
                ?.node?.gatsbyImageData && (
                <GatsbyImage
                  className='main-nav-secondary__highlight-image'
                  image={getImage(
                    panel.detailModulePanel.value.cardDetails.content.cardImage
                      .node.gatsbyImageData
                  )}
                  alt={
                    panel?.detailModulePanel?.value?.cardDetails?.content
                      ?.cardImage?.value?.title || ''
                  }
                />
              )}
            {(panel.detailModulePanel?.value?.__typename ===
              'LiferayModuleDetailBlog' ||
              panel.detailModulePanel?.value?.__typename ===
                'LiferayModuleDetailIniziative') &&
              panel?.detailModulePanel?.value?.blogPost?.content
                ?.imageDetailPost?.node?.gatsbyImageData && (
                <GatsbyImage
                  className='main-nav-secondary__highlight-image'
                  image={getImage(
                    panel.detailModulePanel.value.blogPost.content
                      .imageDetailPost.node.gatsbyImageData
                  )}
                  alt={
                    panel?.detailModulePanel?.value?.blogPost?.content
                      ?.imageDetailPost?.value?.title || ''
                  }
                />
              )}
            {panel.detailModulePanel?.value?.__typename ===
              'LiferayModuleDetailProduct' &&
              panel.detailModulePanel?.value && (
                <span
                  className='main-nav-secondary__category'
                  style={{
                    '--bg-category': `var(${
                      getColorsCategory(
                        panel.detailModulePanel?.value?.liferayFields
                          ?.taxonomyCategoryBriefs
                      ).primary
                    })`,
                  }}
                >
                  {
                    getColorsCategory(
                      panel.detailModulePanel?.value?.liferayFields
                        ?.taxonomyCategoryBriefs
                    ).nameCategory
                  }
                </span>
              )}
            {(panel.detailModulePanel?.value?.__typename ===
              'LiferayModuleDetailBlog' ||
              panel.detailModulePanel?.value?.__typename ===
                'LiferayModuleDetailIniziative') &&
              panel.detailModulePanel?.value &&
              panel.detailModulePanel?.value?.liferayFields
                ?.taxonomyCategoryBriefs?.length && (
                <ul className='main-nav-secondary__blog-categories'>
                  {panel.detailModulePanel?.value?.liferayFields?.taxonomyCategoryBriefs.map(
                    (category, index) => (
                      <li
                        key={index}
                        className='main-nav-secondary__blog-category'
                        style={{
                          '--bg-category': `var(${
                            category?.description?.split('=')[1]
                          })`,
                        }}
                      >
                        {category?.name}
                      </li>
                    )
                  )}
                </ul>
              )}
            {(panel?.detailModulePanel?.value?.detailPageTitle?.value ||
              panel?.detailModulePanel?.value?.cardDetails?.content?.cardTitle
                ?.value) && (
              <Wrapper
                className={classNames('main-nav-secondary__highlight-product', {
                  'main-nav-secondary__highlight-product--blog-detail':
                    panel.detailModulePanel?.value?.__typename ===
                      'LiferayModuleDetailBlog' ||
                    panel.detailModulePanel?.value?.__typename ===
                      'LiferayModuleDetailIniziative',
                })}
                to={panel.detailModulePanel.value.link}
                tag='span'
                component={panel?.detailModulePanel?.value?.link && Link}
              >
                <span>
                  {panel.detailModulePanel.value.cardDetails.content.cardTitle
                    .value ||
                    panel.detailModulePanel.value.detailPageTitle.value}
                </span>
              </Wrapper>
            )}
            {panel?.titlePanel?.value && !panel.detailModulePanel?.value && (
              <Wrapper
                className='main-nav-secondary__title'
                to={panel.titlePanel.content.titleLinkPanel.value}
                tag='span'
                component={
                  panel.titlePanel?.content?.titleLinkPanel?.value && Link
                }
              >
                {panel?.titlePanel?.value && (
                  <span>{panel.titlePanel.value}</span>
                )}
              </Wrapper>
            )}
            {panel?.descriptionPanel?.value && !panel.detailModulePanel?.value && (
              <div className='box-editorial main-nav-secondary__body'>
                <ContenutoHtmlInner
                  rawContent={panel?.descriptionPanel?.value}
                />
              </div>
            )}
            {linkInformation?.label &&
              linkInformation?.link &&
              !panel.detailModulePanel?.value && (
                <ButtonWithLink
                  type='secondary'
                  href={linkInformation.link}
                  text={linkInformation.label}
                  icon={ArrowRightCircle}
                  order={'icon-right'}
                  className='main-nav-secondary__button'
                ></ButtonWithLink>
              )}
          </div>
        )}
    </>
  );
}
export default MegaMenuPanel;
